"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byteStringsCodec = exports.byteStringCodec = exports.ByteStringCodec = void 0;
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
const compact_int_codec_1 = require("./compact-int-codec");
const codec_1 = require("./codec");
const utils_1 = require("../utils");
const array_codec_1 = require("./array-codec");
class ByteStringCodec extends codec_1.Codec {
    encode(input) {
        return (0, utils_1.concatBytes)([compact_int_codec_1.i32Codec.encode(input.length), input]);
    }
    _decode(input) {
        const length = compact_int_codec_1.i32Codec._decode(input);
        return input.consumeBytes(length);
    }
}
exports.ByteStringCodec = ByteStringCodec;
exports.byteStringCodec = new ByteStringCodec();
exports.byteStringsCodec = new array_codec_1.ArrayCodec(exports.byteStringCodec);
